export const StepZeroEntity = {
  announcement_type: null,
  owner: null,
}

export const validateStepZero = values => {
  const errors = {}

  if (!values.announcement_type) {
    errors.announcement_type = 'Selecione o tipo de anúncio'
  }

  if (values.announcement_type === 'property' && !values.owner) {
    errors.owner = 'É obrigatório vincular um proprietário'
  }

  return errors
}

export const stepZeroOnChange = (ent, { path }) => {
  let updated = { ...ent }

  if (path === 'announcement_type' && ent.announcement_type !== 'property') {
    updated.owner = null
  }

  return updated
}
